module.exports = __webpack_public_path__ + "img/notjoinbg.a56eee73.png";